import type { FunctionComponent } from 'react';
import type { ConnectedProps } from 'react-redux';

import type { JobsJobElasticSchemaWithId } from '@iconik-io/iconik-api/src/services/jobs';

import { JOB_MODAL } from '../../../constants/modals';
import connector from './connector';

import styles from './title_button.module.css';

type Props = ConnectedProps<typeof connector> & {
  job: JobsJobElasticSchemaWithId;
};

const TitleButton: FunctionComponent<Props> = ({ job, openModal }) => (
  <div className={styles.root}>
    <a
      className={styles.link}
      onClick={(event) => {
        event.preventDefault();
        openModal({ id: JOB_MODAL, contextItems: [job] });
      }}
    >
      {job.title}
    </a>
  </div>
);

export default connector(TitleButton);
